import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import DmtInvoice from './dmtInvoice';
import './invoicePage.css';

function InvoicePage() {
    const { transactionId } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);

    const handleBack = () => {
        history.goBack();
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 200);
        return () => clearTimeout(timer);
    }, [transactionId]);

    return (
        <div className="invoice-page-layout compact">
            {/* Compact Header */}
            {/* <div className="compact-page-header">
                <button 
                    onClick={handleBack}
                    className="compact-back-btn"
                    title="Go back"
                >
                    <i className="fa fa-arrow-left" />
                </button>
                <div className="compact-header-title">
                    <h3>Transaction Receipt</h3>
                    <span className="compact-transaction-id">
                        <i className="fa fa-hashtag" /> {transactionId}
                    </span>
                </div>
            </div> */}

            {/* Main Content */}
            <div className="invoice-page-content compact">
                {loading ? (
                    <div className="compact-loading">
                        <div className="compact-spinner">
                            <div className="spinner-circle"></div>
                        </div>
                        <p>Loading receipt...</p>
                    </div>
                ) : (
                    <div className="invoice-container-compact">
                        <DmtInvoice 
                            transactionId={transactionId}
                            onClose={handleBack}
                            isPageView={true}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default InvoicePage;